/*
 * @Author: wyh
 * @Date: 2017-10-27
 * @Last Modified by: wyh
 * @Last Modified time: 2019-06-21 10:39:42
 * @Description:
 *      弹出窗口服务
 *      1、showConfrimDialog--显示表单返回提示窗口
 *      2、showApprovalDialog--显示审批提示窗口
 *      3、showCurrencyDialog--显示币种选择提示窗口
 *
 */
import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import {
  AlertController,
  PopoverController,
  Alert,
  ModalController,
} from "ionic-angular";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class DialogService {
  result;
  _COMMON: any;
  insureAlert: Alert;

  constructor(
    private alertCtrl: AlertController,
    private popCtrl: PopoverController,
    private translateSer: TranslateService,
    private modalCtrl: ModalController,
  ) {
    var _Z = setInterval(() => {
      this.translateSer.get("COMMON").subscribe((v) => {
        if (typeof v == "object") {
          this._COMMON = v;
          clearInterval(_Z);
        }
      });
    }, 150);
  }

  /**
   *表单返回提示
   * @param title:提示框的标题
   * @param msg：提示信息
   * @param callback：点击确认按钮之后的回调，在component中进行业务处理
   */
  showConfrimDialog(title, msg, callback) {
    const alert = this.alertCtrl.create({
      title: title,
      message: msg,
      buttons: [
        {
          text: this._COMMON.BUTTON.CANCEL,
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          },
        },
        {
          text: this._COMMON.BUTTON.OK,
          handler: () => {
            callback();
          },
        },
      ],
    });
    alert.present();
  }

  /**
   * 表单审批
   * @param title：标题
   * @param msg：信息
   * @param placemsg：输入框提示信息
   * @param btnmsg：确认按钮显示的文字（同意、驳回）
   * @param callback：点击确认按钮之后的回调函数
   */
  showApprovalDialog(title, msg, placemsg, btnmsg, callback) {
    const alert = this.alertCtrl.create({
      title: title,
      message: msg,
      inputs: [
        {
          name: "title",
          placeholder: placemsg,
        },
      ],
      buttons: [
        {
          text: this._COMMON.BUTTON.CANCEL,
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          },
        },
        {
          text: btnmsg,
          handler: (data) => {
            console.log(data);
            callback(data);
          },
        },
      ],
    });
    alert.present();
  }

  /**
   * 币种选择
   */
  showCurrencyDialog() {
    const alert = this.alertCtrl.create();
    alert.setTitle(this._COMMON.MODAL.SELECT_CURRENCY);
    const dataSource = [
      { id: 1, name: "人民币" },
      { id: 2, name: "美元" },
      { id: 3, name: "欧元" },
    ];
    dataSource.forEach((item) => {
      alert.addInput({
        type: "radio",
        label: item.name,
        value: JSON.stringify(item),
      });
    });
    // alert.addInput({
    //     type: 'radio',
    //     label: this._COMMON.RMB,
    //     value: "{id:1,name:人民币}",
    //     checked: true
    // });

    // alert.addInput({
    //     type: 'radio',
    //     label: this._COMMON.DOLLAR,
    //     value: this._COMMON.DOLLAR
    // });

    // alert.addInput({
    //     type: 'radio',
    //     label: this._COMMON.EURO,
    //     value: this._COMMON.EURO
    // });

    // alert.addInput({
    //     type: 'radio',
    //     label: this._COMMON.YEN,
    //     value: this._COMMON.YEN
    // });

    // alert.addInput({
    //     type: 'radio',
    //     label: this._COMMON.POUND,
    //     value: this._COMMON.POUND
    // });

    alert.addButton(this._COMMON.BUTTON.OK);
    // alert.addButton(this._COMMON.BUTTON.CANCEL);
    return alert;
  }

  /**
   * 用户自定义alert
   * @param options 创建alert数据项
   */
  create(options?) {
    return this.alertCtrl.create(options);
  }

  /**
   * 需要确定的弹出框
   * @param title 标题
   * @param subTitle 二级标题
   */
  alert(
    title: string = this._COMMON.TITLE,
    subTitle: string = "",
    buttons?: Array<any>,
  ): Alert {
    const _buttons = buttons ? buttons : [{ text: this._COMMON.BUTTON.OK }];
    if (this.insureAlert) {
      this.insureAlert.setTitle(title);
      this.insureAlert.setSubTitle(subTitle);
    } else {
      this.insureAlert = this.alertCtrl.create({
        title: title,
        subTitle: subTitle,
        buttons: _buttons,
      });
      this.insureAlert.present();
      this.insureAlert.onWillDismiss((res) => {
        this.insureAlert = undefined;
      });
    }
    return this.insureAlert;
  }

  /**
   * 需要确定的弹出框
   * @param title 标题
   * @param subTitle 二级标题
   */
  // alertR(title: string = this._COMMON.TITLE, subTitle: string = "", buttons?: Array<any>): Alert {
  //     const _buttons = buttons ? buttons : [{ text: this._COMMON.BUTTON.OK }];
  //     return this.alertCtrl.create({
  //         title: title,
  //         subTitle: subTitle,
  //         buttons: _buttons
  //     })
  // }

  /**
   * 带弹出输入意见的dialog
   * @param title 标题
   * @param subTitle 副标题
   * @param placeholder 输入区域提示
   * @param cancel 取消按钮文案
   * @param ensure 确定按钮文案
   * @param msgNess {required：输入信息是否必填,remind：必填情况下用户没有填写应该显示的提示信息}
   */
  showEnterMesDialog(
    title?,
    subTitle?,
    placeholder?,
    cancel?,
    ensure?,
    msgNess?,
  ) {
    return this.popCtrl.create("InputDialogPage", {
      title: title,
      subTitle: subTitle,
      placeholder: placeholder,
      cancel: cancel,
      ensure: ensure,
      msgNess: msgNess,
    });
  }

  /**
   * 带弹出输入意见的dialog
   * @param title 标题
   * @param label 副标题
   * @param placeholder 输入区域提示
   * @param cancel 取消按钮文案
   * @param ensure 确定按钮文案
   * @param isUrgent 是否加急
   * @param others 配置另外的输入 单选 多选等
   * @param msgNess {required：输入信息是否必填,remind：必填情况下用户没有填写应该显示的提示信息}
   * @param changeFlag {控制实际出差日期是否显示}
   * @param dateTime 起始最小时间
   */
  hisenseApproval(
    title?,
    label?,
    placeholder?,
    cancel?,
    ensure?,
    isUrgent?,
    others?,
    msgNess?,
    textShow?,
    changeFlag?,
    dateTime?,
  ) {
    return this.modalCtrl.create("ApprovalDialogPage", {
      title: title,
      label: label,
      placeholder: placeholder,
      cancel: cancel,
      ensure: ensure,
      isUrgent,
      others,
      msgNess: msgNess,
      textShow,
      changeFlag,
      dateTime,
    });
    // return this.popCtrl.create("ApprovalDialogPage", {
    //     title: title,
    //     label: label,
    //     placeholder: placeholder,
    //     cancel: cancel,
    //     ensure: ensure,
    //     isUrgent,
    //     others,
    //     msgNess: msgNess
    // });
  }
}



// WEBPACK FOOTER //
// ./src/services/common/dialog/dialog.service.ts